import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DeviceManualFotaComponent } from './manual-fota.component';

const routes: Routes = [
  {
    path: 'manual-fota',
    data: { name: 'Manual FOTA', isTab: true },
    component: DeviceManualFotaComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DeviceManualFotaRoutingModule {}
